import { render } from "./PromotionMessage.vue?vue&type=template&id=91a6ef32&scoped=true"
import script from "./PromotionMessage.vue?vue&type=script&lang=js"
export * from "./PromotionMessage.vue?vue&type=script&lang=js"

import "./PromotionMessage.vue?vue&type=style&index=0&id=91a6ef32&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a6ef32"],['__file',"src/views/Home/components/PromotionMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "91a6ef32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('91a6ef32', __exports__)) {
    console.log('reload')
    api.reload('91a6ef32', __exports__)
  }
  
  module.hot.accept("./PromotionMessage.vue?vue&type=template&id=91a6ef32&scoped=true", () => {
    console.log('re-render')
    api.rerender('91a6ef32', render)
  })

}


export default __exports__